
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.25 11H26V8.562c0-.28-.281-.562-.563-.562h-.375a.57.57 0 00-.562.563V11h-9V8.562c0-.28-.281-.562-.563-.562h-.374a.57.57 0 00-.563.563V11h-2.25a2.25 2.25 0 00-2.25 2.25v16.5c0 1.266.984 2.25 2.25 2.25h16.5a2.25 2.25 0 002.25-2.25v-16.5c0-1.219-1.031-2.25-2.25-2.25zm-16.5 1.5h16.5c.375 0 .75.375.75.75v2.25H11v-2.25c0-.375.328-.75.75-.75zm0 18h16.5c.375 0 .75-.328.75-.75V17H11v12.75c0 .422.328.75.75.75zm4.688-7.5a.57.57 0 00.562-.563v-1.875c0-.28-.281-.562-.563-.562h-1.875a.57.57 0 00-.562.563v1.875c0 .328.234.562.563.562h1.874zm5.062-.563a.57.57 0 01-.563.563h-1.875a.542.542 0 01-.562-.563v-1.875a.57.57 0 01.563-.562h1.875c.28 0 .562.281.562.563v1.875zm3.938.563a.57.57 0 00.562-.563v-1.875c0-.28-.281-.562-.563-.562h-1.875a.57.57 0 00-.562.563v1.875c0 .328.234.562.563.562h1.875zM21.5 26.938a.57.57 0 01-.563.562h-1.875a.542.542 0 01-.562-.563v-1.875a.57.57 0 01.563-.562h1.875c.28 0 .562.281.562.563v1.875zm-5.063.562a.57.57 0 00.563-.563v-1.875c0-.28-.281-.562-.563-.562h-1.875a.57.57 0 00-.562.563v1.875c0 .328.234.562.563.562h1.874zM26 26.937a.57.57 0 01-.563.563h-1.875a.541.541 0 01-.562-.563v-1.875a.57.57 0 01.563-.562h1.875c.28 0 .562.281.562.563v1.875z","fill":"#586E8C"}})])
          )
        }
      }
    